import { useEffect } from 'react';

import { useRoomContext, useSettingsContext } from '@src/contexts';

import { BsCameraVideo, BsMic } from 'react-icons/bs';
import { IoMdSettings } from 'react-icons/io';
import { MdAspectRatio } from 'react-icons/md';

const SidebarMenu = () => {
  const { selectedMenuItem, handleChangeSelectedItem } = useSettingsContext();
  const { isMobileDevice, isWebinarAttendee } = useRoomContext();

  useEffect(() => {
    if (isWebinarAttendee) {
      handleChangeSelectedItem('general');
    }
  }, [isWebinarAttendee, handleChangeSelectedItem]);

  return (
    <div className="sidebar-container">
      {!isWebinarAttendee && (
        <>
          <button
            className={`menu-item menu-item-box-shadow ${selectedMenuItem === 'audio' ? 'active' : ''}`}
            onClick={() => handleChangeSelectedItem('audio')}
          >
            <BsMic size={20} />
            <span className="item-title">Audio</span>
          </button>
          <button
            className={`menu-item menu-item-box-shadow ${selectedMenuItem === 'video' ? 'active' : ''}`}
            onClick={() => handleChangeSelectedItem('video')}
          >
            <BsCameraVideo size={20} />
            <span className="item-title">Video</span>
          </button>
          {!isMobileDevice && (
            <button
              className={`menu-item menu-item-box-shadow ${selectedMenuItem === 'aspect' ? 'active' : ''}`}
              onClick={() => handleChangeSelectedItem('aspect')}
            >
              <MdAspectRatio size={20} />
              <span className="item-title">Aspect</span>
            </button>
          )}
        </>
      )}
      <button
        className={`menu-item menu-item-box-shadow ${selectedMenuItem === 'general' ? 'active' : ''}`}
        onClick={() => handleChangeSelectedItem('general')}
      >
        <IoMdSettings size={20} />
        <span className="item-title">General</span>
      </button>
    </div>
  );
};

export default SidebarMenu;
